import { HHSelect, HHStack } from '@hinge-health/react-component-library';
import { Controller, useFormContext } from 'react-hook-form';
import { capitalizeFirstLetterAndSpaceCamelCaseString } from '../../billing-tool/utils/bills-utils';
import {
  BULK_ADJUSTMENTS_CATEGORY,
  useAdjustmentUploadAccess,
} from './bulk-adjustments';
import { AvailableFileCategories } from './file-upload-types';

export const FileCategorySelect = ({
  availableFileDetails,
}: {
  availableFileDetails: AvailableFileCategories;
}): JSX.Element => {
  const canUploadAdjustments = useAdjustmentUploadAccess();

  const availableFileCategoryNames =
    Object.keys(availableFileDetails ?? {})
      .filter(key => key !== BULK_ADJUSTMENTS_CATEGORY || canUploadAdjustments)
      .map(key => ({
        value: key,
        displayName: capitalizeFirstLetterAndSpaceCamelCaseString(key),
      })) ?? [];

  const { control, setValue } = useFormContext();

  return (
    <HHStack spacing={6} direction="column">
      <Controller
        control={control}
        name="fileCategorySelect"
        render={({ field: { onChange, value } }): JSX.Element => (
          <HHSelect
            id="file-category-select"
            label="File Category"
            initialSelectValue={value}
            selectOptions={availableFileCategoryNames}
            onChange={(e): void => {
              onChange(e.target.value);
              // Each category has its own file rules, so a file picked
              // under the old category may not be valid for the new one.
              setValue('file', null);
            }}
          />
        )}
      />
    </HHStack>
  );
};
